import { AudioType } from 'modules/AnchorAPI/v3/episodes/fetchEpisodeAudio';
import { getApiUrl } from '../../../Url';

/* 
  New endpoint to replace and deprecate public-website 
  API /api/podcastepisode/:podcastEpisodeId into server-api. 
  
  TODO: complete refactor of EpisodeEditorPublish,
  EpisodeEditorPublishContainer, EpisodeMetadataPublishContainer to 
  remove redux and transition fully to pull from this new endpoint. 
  More info https://anchorfm.atlassian.net/browse/WHEEL-839
*/

type FetchEpisodeOverviewParams = {
  webEpisodeId: string;
};

export type EpisodeAudios = {
  url: string;
  caption: string;
  duration: number;
  webAudioId: string;
  color: string;
  type: AudioType;
  audioTransformationName: string;
  derivedFromAudioId: boolean;
};

// Note: this response type is missing values
type FetchEpisodeOverviewResponse = {
  episodeAudios: EpisodeAudios[];
  title: string;
  totalDuration: number;
  totalSize: number;
  videoPodcastingEpisode: boolean;
  isPaywallContent: boolean;
};

export async function fetchEpisodeOverview({
  webEpisodeId,
}: FetchEpisodeOverviewParams): Promise<FetchEpisodeOverviewResponse> {
  try {
    const response = await fetch(
      getApiUrl({
        path: `episodes/webEpisodeId:${webEpisodeId}/overview`,
        queryParameters: {
          returnWebIds: true,
        },
      }),
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );

    if (response.ok) {
      return response.json();
    }
    throw new Error('Error fetching episode overview');
  } catch (e) {
    throw new Error(e.message);
  }
}
